import { IonSpinner } from '@ionic/react';
import './Loading.css';

const Loading: React.FC = () => <div><IonSpinner className='loading'></IonSpinner></div>;

export default Loading;